import { apiJson } from './apiFetch';
import { campaignHeaders, defineQuery } from '../../lib/data';
import type { ContactAnalyticsResponse } from '@signalvote/shared';

const contactAnalytics = defineQuery({
  key: ({ volunteerId, vendorId }: { volunteerId?: string; vendorId?: string }) => ['analytics', 'contactAnalytics', volunteerId ?? null, vendorId ?? null],
  reads: 'GET /api/Analytics/contact-analytics',
  staleTime: 5 * 60 * 1000,
  fetch: ({ volunteerId, vendorId }, { signal, campaignId }) => {
    const searchParams = new URLSearchParams();
    if (volunteerId) searchParams.set('volunteerId', volunteerId);
    if (vendorId) searchParams.set('vendorId', vendorId);
    const qs = searchParams.toString();
    return apiJson<ContactAnalyticsResponse>(`/api/analytics/contact-analytics${qs ? `?${qs}` : ''}`, {
      signal,
      headers: campaignHeaders(campaignId),
      error: 'Failed to fetch contact analytics',
    });
  },
});

/** Contact analytics, optionally scoped to a single volunteer and/or vendor. */
export function useContactAnalytics(volunteerId?: string, vendorId?: string) {
  return contactAnalytics({ volunteerId, vendorId });
}
